import type { v2 } from '@sap/ux-specification-types';
import { ControlType } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { addPatternForBindingChangeOfEnumOP, buildControlIdFromParent } from '../../../common/decoration';

const getControlId = (baseId: string, idBreadcrumbs: string[]): string => {
    const idBreadcrumbsCopy = idBreadcrumbs.slice(0);
    idBreadcrumbsCopy[idBreadcrumbs.length - 1] = 'objectPage';
    return buildControlIdFromParent(baseId, idBreadcrumbsCopy);
};

export class ObjectPageLayout implements v2.ObjectPageLayout {
    @syncRule({
        flex: {
            controlId: getControlId,
            controlType: (): ControlType => ControlType.ObjectPageLayout
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    showHeaderContent?: boolean;

    @syncRule({
        flex: {
            controlId: getControlId,
            controlType: (): ControlType => ControlType.ObjectPageLayout
        }
    })
    showAnchorBar?: boolean;

    @syncRule({
        flex: {
            controlId: getControlId,
            controlType: (): ControlType => ControlType.ObjectPageLayout
        }
    })
    useIconTabBar?: boolean;

    @syncRule({
        flex: {
            controlId: getControlId,
            controlType: (): ControlType => ControlType.ObjectPageLayout
        }
    })
    @validity({
        since: '1.34.0'
    })
    alwaysShowContentHeader?: boolean;
}
